import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config';

import { getApiClient } from './api-client';

export type Policies = {
  policies: string[];
};

const getConfigurationBaseUrl = () => {
  const { configuration } = getEnvironmentApiUrls().graphQl;
  return configuration.replace(/\/graphql\/?$/, '');
};

export const configurationApi = () => {
  const api = getApiClient(getConfigurationBaseUrl());

  const getPolicies = async () => {
    const response = await api.get<Policies>('/policies');
    return response.data;
  };

  return {
    getPolicies,
  };
};
